import React, {useState} from 'react';
import {
  HashRouter as Router,
  Switch,
  Route
} from 'react-router-dom';

import './App.css';

import Top from './components/top';
import Home from './components/home';
import RollCall from './components/rollCall';
import End from './components/end'

function App() {
  const [ roll , setRoll ] = useState({
    limits: [1,45],
    register: {}
  })

  const [data, setData] = useState({
    lecture: 0,
    class: 10,
    section: 'A',
    subject: 'Social Science',
    date: Date(Date.now()).split('202')[0]
  })

  const [ absent , setAbsent ] = useState([])
  const [ test , setTest ] = useState([0])
  return (  
     <div> 
      <Top />
      <Router>
        
          <Route 
            path='/' exact 
            component={() => 
              <Home 
                roll = {roll} 
                setRoll = { (roll) => setRoll(roll) }
                data = {data}
                setData = {(data) => setData(data)}  />}
          />
          <Route 
            path = '/rollCall' exact
            component = { () => 
              <RollCall 
                roll = { roll } 
                setRoll = { (roll) => setRoll(roll) }
                data = {data} 
              />} 
          />
        
      </Router>
    </div>
  );
}

export default App;
